/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".form-group[_ngcontent-%COMP%]   .col-md-2.txt[_ngcontent-%COMP%]{\r\n    padding-top: 20px;\r\n}"];
export { styles as styles };
